import { ApiError } from '../api/core/ApiError';

/** Normaliza mensajes del API (Nest) a texto legible en español para la UI. */
export function parseCustomerApiErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const body = error.body;
    let raw = '';
    if (body && typeof body === 'object' && 'message' in body) {
      const m = (body as { message: unknown }).message;
      if (Array.isArray(m)) raw = m.map(String).join(' ');
      else if (typeof m === 'string') raw = m;
    }
    if (!raw) raw = error.message || '';
    return translateKnownCustomerMessages(raw);
  }
  if (error instanceof Error) return translateKnownCustomerMessages(error.message);
  return 'Ocurrió un error inesperado.';
}

function translateKnownCustomerMessages(text: string): string {
  const t = text.trim();
  const lower = t.toLowerCase();

  if (lower.includes('cannot delete customer profile with active orders')) {
    return 'No se puede eliminar: el cliente tiene pedidos activos (no cancelados ni devueltos).';
  }
  if (lower.includes('customer with email') && lower.includes('already exists')) {
    return 'Ya existe un cliente con ese correo electrónico.';
  }
  if (lower.includes('customer profile with id') && lower.includes('not found')) {
    return 'No se encontró el cliente.';
  }
  if (lower.includes('internal server error')) {
    return 'Error interno del servidor. Intente de nuevo.';
  }

  return t;
}
